<template>
  <div class="w-[650px] gap-y-[60px] flex flex-col">
    <div class="w-full ml-[80px] text-grays-900 font-medium text-xl">
      <div class="font-bold">
        ממש עכשיו אתם מתחילת את הקניה ב"שם המכירה" תמיד אפשר לבדוק בלוח המכירות
        ולפתוח הזמנה במכירה חדשה שקיימת.נשאר לכם רק לאשר ואפשר להתחיל למלא את
        הבית בדברים טובים.
      </div>
    </div>
    <div class="flex-col gap-[20px] flex">
      <div class="flex flex-row items-center gap-[11px]">
        <div class="text-complementary-800 material-symbols-rounded">error</div>
        <div class="text-grays-900 font-medium text-base">
          מזכירים לכם, בעת ביצוע ההזמנה הנכם מתחייבים לבוא בזמן לנקודת האיסוף
          שבחרתם ולאסוף את ההזמנה תוך שמירה על הניקיון והסדר במקום.
        </div>
      </div>
      <div class="flex flex-row items-center gap-[11px]">
        <div class="text-complementary-800 material-symbols-rounded">error</div>
        <div class="text-grays-900 font-medium text-base">
          לא נוכל לזכות אתכם במקרים של שכחה או טעות מצידכם.
        </div>
      </div>
      <div class="flex flex-row items-center gap-[11px]">
        <div class="text-complementary-800 material-symbols-rounded">error</div>
        <div class="text-grays-900 font-medium text-base">
          במקרה של התנתקות מהאתר מכל סיבה שהיא ההזמנה נשמרת ותחויב באשראי
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CompleteRegistrationPage3",
  data() {
    return {};
  },
};
</script>

<style>
</style>